import coverApi from '@/services/CoverApi'
import dayjs from 'dayjs'

export default {
  namespaced: true,
  state: {
    tabs: [
      { key: 'coversquoted', name: 'Cover.ListCover.QUOTED_MENU_LINK', route: '/quoted', totalCoversCount: '' },
      { key: 'coversactivated', name: 'Cover.ListCover.ACTIVATED_MENU_LINK', route: '/activated', totalCoversCount: '' },
      { key: 'coverslate', name: 'Cover.ListCover.LATE_MENU_LINK', route: '/', totalCoversCount: '' },
      { key: 'coverssettled', name: 'Cover.ListCover.SETTLED_MENU_LINK', route: '/settled', totalCoversCount: '' },
      { key: 'coversclaimed', name: 'Cover.ListCover.CLAIMED_MENU_LINK', route: '/claimed', totalCoversCount: '' },
      { key: 'coversarchived', name: 'Cover.ListCover.ARCHIVED_MENU_LINK', route: '/archived', totalCoversCount: '' },
      { key: 'coverstimebarred', name: 'Cover.ListCover.TIMEBARRED_MENU_LINK', route: '/timebarred', totalCoversCount: '' }
    ],
    filters: {
      identifierValue: '',
      identifierTypeCode: '',
      identifierCountryCode: ''
    }
  },
  mutations: {
    setCoversTabCount (state, tab) {
      state.tabs.forEach((element, index) => {
        if (element.name === tab.name) {
          state.tabs[index].totalCoversCount = tab.totalCount
        }
      })
    },
    setFilters (state, value) {
      state.filters = value
    },
    setCoversTabCountByKey (state, tab) {
      state.tabs.forEach((element, index) => {
        if (element.key === tab.key) {
          state.tabs[index].totalCoversCount = tab.totalCount
        }
      })
    }
  },
  actions: {
    setCoversLateCount (context, totalCount) {
      let tab = {
        name: 'Cover.ListCover.LATE_MENU_LINK',
        totalCount: totalCount
      }
      context.commit('setCoversTabCount', tab)
    },
    setCoversTabCountByKey (context, tab) {
      context.commit('setCoversTabCountByKey', tab)
    },
    setCoversClaimedCount (context, totalCount) {
      let tab = {
        name: 'Cover.ListCover.CLAIMED_MENU_LINK',
        totalCount: totalCount
      }
      context.commit('setCoversTabCount', tab)
    },
    async updateCoversLateCount (context) {
      let to = dayjs().format('MM/DD/YYYY')
      await coverApi.fetchCoversbyStatusPerPage(1, 10, null, 'claimableat', to, to, 'dueat', 'desc', null).then((result) => {
        context.dispatch('setCoversLateCount', result.totalCount)
      }).catch((err) => {
        console.log(err)
      })
    },
    setFilters (context, value) {
      context.commit('setFilters', value)
    }
  }
}
